<template>
  <v-dialog v-model="addDialog" class="the-app-dialogs" persistent max-width="800px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
              <span class="px-3">{{ $t('Add New Promotion') }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="headline no-select pb-1">
              <v-layout justify-end></v-layout>
            </v-flex>

            <v-layout row wrap>
              <v-flex xs12 sm12 md12 class="py-1 px-2">
                <v-text-field
                  id="promotion-focus-me"
                  v-model="form.promo_name"
                  :label="`${$t('Promotion Name')} *`"
                  name="Promotion Name"
                  hide-details
                  box
                  background-color="white"
                  :error="errors.has('Promotion Name')"
                  v-validate="'required'"
                />
              </v-flex>

              <v-flex xs12 pa-2>
                <v-autocomplete
                  v-model="form.promo_outlet"
                  :items="outletsList"
                  :label="`${$t('Outlet')} *`"
                  box
                  hide-details
                  multiple
                  chips
                  deletable-chips
                  background-color="white"
                  class="text-capitalize"
                  :error="errors.has('Outlet')"
                  data-vv-name="Outlet"
                  v-validate="'required'"
                  :menu-props="{ transition: 'slide-y-transition' }"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index < 3">
                      <span>{{ item.text }}</span>
                    </v-chip>
                    <span v-if="index === 3" class="grey--text caption"
                      >(+{{ form.promo_outlet.length - 3 }} others)</span
                    >
                  </template>
                  <template v-slot:prepend-item>
                    <v-list-tile ripple @click="toggle">
                      <v-list-tile-action>
                        <v-icon
                          :color="
                            form.promo_outlet != null ? (form.promo_outlet.length > 0 ? 'indigo darken-4' : '') : ''
                          "
                          >{{ icon }}</v-icon
                        >
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>Select All</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider />
                  </template>
                </v-autocomplete>
              </v-flex>

              <v-flex xs4 sm4 class="pa-2">
                <v-menu v-model="startDateMenu" full-width max-width="290" :close-on-content-click="false">
                  <v-text-field
                    slot="activator"
                    :value="form.promo_start_date"
                    :label="`${$t('Start Date')}`"
                    prepend-inner-icon="event"
                    box
                    readonly
                    hide-details
                    name="Start Date"
                    background-color="white"
                    autocomplete="off"
                    :error="errors.has('Start Date')"
                    v-validate="'date_format:yyyy-MM-dd'"
                    ref="Start Date"
                  />
                  <v-date-picker @change="startDateMenu = false" v-model="form.promo_start_date" />
                </v-menu>
              </v-flex>
              <v-flex xs4 sm4 class="pa-2">
                <v-menu v-model="endDateMenu" full-width max-width="290" :close-on-content-click="false">
                  <v-text-field
                    slot="activator"
                    :value="form.promo_end_date"
                    :label="`${$t('End Date')}`"
                    prepend-inner-icon="event"
                    box
                    readonly
                    hide-details
                    background-color="white"
                    name="End Date"
                    autocomplete="off"
                    :error="errors.has('End Date')"
                    v-validate="'date_format:yyyy-MM-dd|after:Start Date'"
                  />
                  <v-date-picker @change="endDateMenu = false" v-model="form.promo_end_date" />
                </v-menu>
              </v-flex>
              <v-flex xs4 sm4 class="pa-2">
                <v-autocomplete
                  :items="customerRules"
                  v-model="form.promo_customer_rule"
                  :label="`${$t('Customer Rule')} *`"
                  box
                  hide-details
                  browser-autocomplete
                  :error="errors.has('Customer Rule')"
                  background-color="white"
                  v-validate="'required'"
                  data-vv-name="Customer Rule"
                  :menu-props="{ transition: 'slide-y-transition' }"
                />
              </v-flex>

              <v-flex xs12 sm12 pa-2 v-if="form.promo_customer_rule === 'Group'">
                <v-autocomplete
                  v-model="form.promo_customer_group"
                  :items="customerGroupsList"
                  :label="`${$t('Customer Group')} *`"
                  box
                  hide-details
                  deletable-chips
                  multiple
                  chips
                  browser-autocomplete
                  :error="errors.has('Customer Group')"
                  background-color="white"
                  v-validate="'required'"
                  data-vv-name="Customer Group"
                  :menu-props="{ transition: 'slide-y-transition' }"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index < 3">
                      <span>{{ item.text }}</span>
                    </v-chip>
                    <span v-if="index === 3" class="grey--text caption"
                      >(+{{ form.promo_customer_group.length - 3 }} others)</span
                    >
                  </template>
                </v-autocomplete>
              </v-flex>

              <v-flex xs12 sm12 class="pa-2">
                <v-autocomplete
                  :items="productRules"
                  v-model="form.promo_product_rule"
                  :label="`${$t('Product Rule')} *`"
                  box
                  hide-details
                  :error="errors.has('Product Rule')"
                  background-color="white"
                  v-validate="'required'"
                  data-vv-name="Product Rule"
                  :menu-props="{ transition: 'slide-y-transition' }"
                />
              </v-flex>

              <v-flex xs12 sm12 pa-2 v-if="form.promo_product_rule === 'Product Type'">
                <v-autocomplete
                  v-model="form.promo_customer_product_type"
                  :items="productTypesList"
                  :label="`${$t('Product Type')} *`"
                  box
                  hide-details
                  multiple
                  chips
                  deletable-chips
                  browser-autocomplete
                  :error="errors.has('Product Type')"
                  background-color="white"
                  v-validate="'required'"
                  data-vv-name="Product Type"
                  :menu-props="{ transition: 'slide-y-transition' }"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index < 3">
                      <span>{{ item.text }}</span>
                    </v-chip>
                    <span v-if="index === 3" class="grey--text caption"
                      >(+{{ form.promo_customer_product_type.length - 3 }} others)</span
                    >
                  </template>
                </v-autocomplete>
              </v-flex>

              <v-flex xs12 sm12 class="pa-2" v-if="form.promo_product_rule === 'Specific Products'">
                <v-autocomplete
                  v-model="form.specific_products"
                  :items="productListSalesList"
                  :label="`${$t('Specific Product')} *`"
                  box
                  hide-details
                  multiple
                  chips
                  deletable-chips
                  browser-autocomplete
                  :error="errors.has('Specific Product')"
                  background-color="white"
                  v-validate="'required'"
                  data-vv-name="Specific Product"
                  :menu-props="{ transition: 'slide-y-transition' }"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index < 3">
                      <span>{{ item.text }}</span>
                    </v-chip>
                    <span v-if="index === 3" class="grey--text caption"
                      >(+{{ form.specific_products.length - 3 }} others)</span
                    >
                  </template>
                </v-autocomplete>
              </v-flex>

              <v-flex xs6 sm6 class="pa-2">
                <v-autocomplete
                  :items="amountRuleTypes"
                  v-model="form.promo_rule_amount_or_quantity"
                  :label="`${$t('Amount Rule Type')} *`"
                  box
                  hide-details
                  :error="errors.has('Amount Rule Type')"
                  background-color="white"
                  v-validate="'required'"
                  data-vv-name="Amount Rule Type"
                  :menu-props="{ transition: 'slide-y-transition' }"
                />
              </v-flex>
              <v-flex xs6 sm6 class="pa-2">
                <v-text-field
                  v-model="form.promo_rule_value"
                  :label="`${$t('Rule Value')} *`"
                  name="Rule Value"
                  hide-details
                  box
                  background-color="white"
                  :error="errors.has('Rule Value')"
                  v-validate="
                    form.promo_rule_amount_or_quantity === 'Item Quantity'
                      ? 'required|decimal:3|min_value:1'
                      : 'required|decimal:3|min_value:1'
                  "
                  data-vv-delay="1000"
                />
              </v-flex>
              <v-flex xs6 sm6 class="pa-2">
                <v-autocomplete
                  :items="rewardTypes"
                  v-model="form.promo_reward_type"
                  :label="`${$t('Reward Type')} *`"
                  box
                  hide-details
                  :error="errors.has('Reward Type')"
                  background-color="white"
                  v-validate="'required'"
                  data-vv-name="Reward Type"
                  :menu-props="{ transition: 'slide-y-transition' }"
                />
              </v-flex>
              <v-flex xs6 sm6 class="pa-2">
                <v-text-field
                  v-model="form.promo_reward_value"
                  :label="`${$t('Reward Value')} *`"
                  name="Reward Value"
                  hide-details
                  box
                  :suffix="form.promo_reward_type === 'Get Discount' ? '%' : ''"
                  background-color="white"
                  :error="errors.has('Reward Value')"
                  v-validate="'required|decimal:3|min_value:1'"
                  data-vv-delay="1000"
                />
              </v-flex>

              <v-flex xs12 sm12 md12 class="pa-2">
                <v-textarea
                  v-model="form.promo_description"
                  :label="$t('Description')"
                  name="promo_description"
                  hide-details
                  box
                  height="80"
                  background-color="white"
                />
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end align-center pr-2 pl-2>
              <v-checkbox color="primary" v-model="keepForm" :label="$t('Keep this form to add another one.')" />

              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnAddLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Add') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'

export default {
  name: 'add-component',

  props: {
    addDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      btnAddLoading: false,
      endDateMenu: false,
      startDateMenu: false,
      form: {
        promo_start_date: '',
        promo_end_date: '',
        promo_outlet: [],
        promo_description: ''
      },
      keepForm: false
    }
  },

  computed: {
    ...mapGetters({
      outletsList: 'outlets/getFullOutletsList',
      customerGroupsList: 'customersGroups/getFullGroupsList',
      productTypesList: 'productTypes/getFullProductTypesList',
      productListSalesList: 'products/getFullSaleProductsList',
      customerRules: 'promotions/getCustomerRules',
      productRules: 'promotions/getProductRules',
      amountRuleTypes: 'promotions/getAmountRuleTypes',
      rewardTypes: 'promotions/getRewardTypes'
    }),

    selectAllOutlet() {
      if (this.form.promo_outlet != null && this.outletsList.length != null) {
        return this.form.promo_outlet.length === this.outletsList.length
      }
    },

    selectSomeOutlet() {
      if (this.form.promo_outlet != null) {
        return this.form.promo_outlet.length > 0 && !this.selectAllOutlet
      }
    },

    icon() {
      if (this.selectAllOutlet) return 'mdi-close-box'
      if (this.selectSomeOutlet) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    }
  },

  watch: {
    addDialog: {
      immediate: false,
      handler() {
        if (this.addDialog) {
          this.addEscKeyListener()
          this.resetForm()
          this.keepForm = false
        }
      }
    }
  },

  methods: {
    ...mapActions({
      addPromotion: 'promotions/addPromotion'
    }),

    hasPermissions(permissions) {
      return helpers.userHasPermissions(permissions)
    },

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the 'ESC' button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.addDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    resetForm() {
      this.$validator.pause()
      for (let key in this.form) {
        this.form[`${key}`] = null
      }
      this.form.promo_start_date = ''
      this.form.promo_end_date = ''
      this.$nextTick(() => {
        this.$validator.resume()
        // default veutify autofocus only one time works so we have to handled in this way.
        // document.getElementById('promotion-focus-me').focus()
      })
    },

    toggle() {
      this.$nextTick(() => {
        if (this.selectAllOutlet) {
          this.form.promo_outlet = []
        } else {
          this.form.promo_outlet = this.outletsList.slice()
        }
      })
    },

    validateBeforeSubmit(event) {
      this.$validator
        .validateAll()
        .then(() => {
          if (!this.errors.any()) {
            this.btnAddLoading = true

            let formData = new FormData(event.target)
            formData.append('promo_name', this.form.promo_name)
            formData.append('promo_customer_rule', this.form.promo_customer_rule)
            formData.append('promo_product_rule', this.form.promo_product_rule)
            formData.append('promo_rule_amount_or_quantity', this.form.promo_rule_amount_or_quantity)
            formData.append('promo_rule_value', this.form.promo_rule_value)
            formData.append('promo_reward_type', this.form.promo_reward_type)
            formData.append('promo_reward_value', this.form.promo_reward_value)
            formData.set('promo_start_date', this.form.promo_start_date)
            formData.set('promo_end_date', this.form.promo_end_date)

            if (this.form.promo_customer_rule === 'Group') {
              this.form.promo_customer_group.forEach((customerGroup, index) => {
                formData.append('promo_customer_group[' + [index] + ']', customerGroup)
              })
            } else {
              this.form.promo_customer_group = []
            }

            if (this.form.promo_product_rule === 'Product Type') {
              this.form.promo_customer_product_type.forEach((ProductType, index) => {
                formData.append('promo_customer_product_type[' + [index] + ']', ProductType)
              })
            } else if (this.form.promo_product_rule === 'Specific Products') {
              this.form.specific_products.forEach((SpecificProducts, index) => {
                formData.append('specific_products[' + [index] + ']', SpecificProducts)
              })
            }

            if (this.selectAllOutlet) {
              this.form.promo_outlet.forEach((outelet, index) => {
                formData.append('promo_outlet[' + [index] + ']', outelet.value)
              })
            } else {
              this.form.promo_outlet.forEach((outelet, index) => {
                formData.append('promo_outlet[' + [index] + ']', outelet)
              })
            }

            this.addPromotion(formData)
              .then(() => {
                this.btnAddLoading = false
                this.$emit('reset-datatable')
                if (this.keepForm) {
                  this.resetForm()
                } else {
                  this.$emit('hidemodal')
                }
              })
              .catch(() => {
                this.btnAddLoading = false
              })
          }
        })
        .catch(() => {
          this.btnAddLoading = false
        })
    }
  }
}
</script>

<style scoped />
